import UUIDBase from '../UUIDBase'
import Dinero, {Currency} from "dinero.js";
import ItemPackCustomPrice from "@/models/inventory/ItemPackCustomPrice";

export default class ItemImage extends UUIDBase {
  itemID = ''
  filename = ''
  isDefault: boolean;

  static from(json: Record<string, unknown> | ItemImage) {
    const itemImage = Object.assign(new ItemImage(), json)

    itemImage.createdAt = new Date(json.createdAt as string)
    itemImage.updatedAt = new Date(json.updatedAt as string)
    itemImage.deletedAt = json.deletedAt ? new Date(json.deletedAt as string) : undefined

    return itemImage
  }

}
